import React, { useState, useContext, useEffect, useRef } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';
import { NotificationContext } from '../Context/NotificationContext';
import { CheckCircle } from 'react-feather';
import { ReactComponent as Star } from "../assets/icons/StartBlue.svg";



import './Reviews.css';
import { firestore } from '../firebase.config';

const pageLimit = 25;

const months = {
  'Jan': 'January',
  'Feb': 'February',
  'Mar': 'March',
  'Apr': 'April',
  'May': 'May',
  'Jun': 'June',
  'Jul': 'July',
  'Aug': 'August',
  'Sep': 'September',
  'Oct': 'October',
  'Nov': 'November',
  'Dec': 'December'
};

const Reviews = ({ windowSize }) => {

  const { setColor, webP } = useContext(TransitionContext);

  const { showNotification } = useContext(NotificationContext);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const [reviews, setReviews] = useState([]);
  const [loadedReviews, setLoadedReviews] = useState(false);
  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

  useEffect(() => {
    
    const unsubscribe = 
      firestore.collection('reviews')
        .orderBy('date', 'desc')
        .limit(pageLimit)
        .onSnapshot(querySnapshot => {
          nextPointer.current = querySnapshot.docs[querySnapshot.docs.length-1];
          
          setReviews(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
          setLoadedReviews(true);
        }, error => {
          showNotification('Error', "There was an error loading the reviews. Please, reload the page.", 'error');
          setLoadedReviews(true);
        });

    return () => unsubscribe();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMoreReviews = () => {
    if (nextPointer.current) {

      firestore.collection('reviews')
        .orderBy('date', 'desc')
        .startAfter(nextPointer.current)
        .limit(pageLimit)
        .get().then((querySnapshot) => {
          nextPointer.current = querySnapshot.docs[querySnapshot.docs.length-1];

          let oldReviews = [];

          querySnapshot.forEach((doc) => {
            oldReviews.push({ id: doc.id, ...doc.data() });
          });
          
          setReviews(u => u.concat(oldReviews));
        })
        .catch((error) => {
          showNotification('Error', "There was an error loading the reviews. Please, reload the page.", 'error');
        });
    }
  }

  const formatDate = timestamp => {
    if (!timestamp) return '';

    const date = new Date(timestamp);

    const splitted = date.toDateString().split(' ');

    return months[splitted[1]] + ' ' + splitted[2] + ', ' + splitted[3];
  }

  const sortName = (name) => {
    const nameArray = name.split(/[ -]/g);
    // console.log(nameArray)
    if(nameArray.length > 3){
      if(nameArray[0] && nameArray[0].length < 2){
        return nameArray[0] + " " + nameArray[1] + " " + nameArray[2].charAt(0)  + ".";
      }
    }
    if(nameArray.length > 1) {
      if(nameArray[0] && nameArray[0].length > 2){
        return nameArray[0] + " " + nameArray[1].charAt(0) + ".";
      }
      return nameArray[0] + " " + nameArray[1] + " " + nameArray[2].charAt(0)  + ".";
    }

    return nameArray[0];
  }

  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>Verified Customer Reviews</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>We are extremely commited to quick turnaround times and quality. Read through some of our customer testimonials to gain a better understanding of how we work.</p>
          <p className='w-full flex items-center justify-center gap-2 text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>
          <CheckCircle color='#fff' size={20}  />
          <p className="text-[#fff] text-center">All reviews from verified customers.</p>
            <p className="text-[#fff] text-center">Have an account? <span className="border-b border-[#fff] cursor-pointer" onClick={(e) => handleLoginOpen(true)}>Sign in</span>.</p>
          </p>
        </div>
      </div>

      <div className=" bg-white rounded-4xl overflow-hidden shadow-sm py-12 my-4 max-md:rounded-xl">
        <div className="px-8 flex flex-col gap-4 justify-center items-center max-w-[1440px] mx-auto w-full">
        <h2 className='font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left mb-6'>CUSTOMER REVIEWS</h2>

        { loadedReviews && reviews.length > 0
        ? reviews.map(review =>
          <div
            className={`opacity-100 w-full max-w-[1440px] mx-auto`}
          >
            <div
              className={`border  ${
                 "border-primary" 
              } rounded-[20px] px-4 py-10 relative w-full`}
            >
              <div className="flex flex-col justify-center w-full items-start gap-4 pb-2">
              {/* <div className="reviewScoreContainer">{parseFloat(review.score).toFixed(1)}</div> */}
                <ul className="flex gap-2">
                  {Array.from({ length: parseFloat(review.score).toFixed(1) }).map((_, index) => (
                    <li key={index}>
                      <Star className="text-primary h-5 w-5" />
                    </li>
                  ))}
                </ul>

              </div>

              <div className={`flex flex-col items-start justify-center gap-[4px]`}>
              <p className="font-normal text-[#666] text-lg text-left leading-[1.5]">{review.text ? '"' + review.text + '"' : ""}</p>
              <p className="font-medium text-[#12ABBF] text-lg text-left leading-[1.5]">{sortName(review.name)}</p>
              <p className="font-normal text-[#666] text-sm text-left leading-[1.5]">{`${review.languageFrom} to ${review.languageTo}`}</p>
              <p className="font-normal text-[#666] text-sm text-left leading-[1.5]">Posted <strong>{formatDate(review.date)}</strong></p>

              </div>
            </div>
          </div>
          )
        : loadedReviews ? <div className="loadingReviews">No reviews.</div> : <div className="loadingReviews">Loading reviews<span className="dotsLoading">...</span></div>
        }
        { loadedReviews && reviews.length >= pageLimit && nextPointer.current &&
          <div className="loadMoreReviewsButton" onClick={() => loadMoreReviews()}>
            Load more reviews...
          </div>
        }
        </div>
      </div>
      

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  
  );
}

export default Reviews;